import { Button, Popover, Stack } from "@mantine/core";
import {
  gridFilterModelSelector,
  gridRowSelectionStateSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid-pro";
import { IconDotsVertical } from "@tabler/icons-react";
import PopOver from "../../../components/View/PopOver";

const TableMoreActions = ({ tableId, actions }) => {
  const apiRef = useGridApiContext();
  const selectedIds = useGridSelector(apiRef, gridRowSelectionStateSelector);
  const filter = useGridSelector(apiRef, gridFilterModelSelector);

  return (
    <PopOver
      opener={(handleOpen, ref) => (
        <Button
          variant="subtle"
          size={"sm"}
          ml={16}
          mr={8}
          miw={0}
          w={38}
          p={0}
          radius={"md"}
          id={"more-actions-" + tableId}
          ref={ref}
          onClick={handleOpen}
        >
          <IconDotsVertical size={24} />
        </Button>
      )}
      popoverChildren={(handleClose) => (
        <Stack gap={"xs"}>{actions({ selectedIds, filter, handleClose })}</Stack>
      )}
    />
  );
};

export default TableMoreActions;
